// import * as constants from '../constants';

// const nms = [ constants.NAMESPACE, 'store', 'state' ].join('/');
// const log = require('debug')('@mycure/vue-plugins/' + nms);

/**
 * @typedef {Object} SnackConfig
 * @property {string} message
 * @property {string} color
 * @property {function} closeCb
 */

const state = {
  /** @type {SnackConfig[]} */
  queue: []
};

export default state;
